import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building, TrendingUp, HardHat, Globe } from "lucide-react";
import Reveal from "../components/Reveal";
import Counter from "../components/Counter";
import SEO from "../components/SEO";
import "./Home.css";

const Home = () => {
  return (
    <div className="home">
      <SEO
        title="Home | Sotak Investment & Property"
        description="Leading real estate investment, property development, and construction company in Abuja. We build your future with integrity and excellence."
        keywords="Real Estate, Property Development, Construction, Investment, Abuja, Sotak"
      />
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <Reveal>
              <h1>
                Building the Future, <br />{" "}
                <span className="text-secondary">Managing Wealth</span>
              </h1>
              <p>
                Sotak Investment and Property Company Ltd is your premier
                partner in real estate development, construction, and strategic
                investments. We deliver excellence across every sector.
              </p>
              <div className="hero-buttons">
                <Link to="/services" className="btn btn-primary">
                  Our Services
                </Link>
                <Link to="/contact#contact-form" className="btn btn-outline-light">
                  Contact Us
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Stats / Trust Section */}
      <section className="section stats-section">
        <div className="container stats-grid">
          <Reveal delay={100} className="stat-item">
            <h2>
              <Counter end={12} suffix="+" />
            </h2>
            <p>Years of Excellence</p>
          </Reveal>
          <Reveal delay={300} className="stat-item">
            <h2>
              <Counter end={25} suffix="+" />
            </h2>
            <p>Projects Completed</p>
          </Reveal>
          <Reveal delay={500} className="stat-item">
            <h2>
              <Counter end={100} suffix="%" />
            </h2>
            <p>Client Satisfaction</p>
          </Reveal>
        </div>
      </section>

      {/* About Preview */}
      <section className="section">
        <div className="container about-preview">
          <div className="about-text">
            <Reveal>
              <h4 className="subtitle">Who We Are</h4>
              <h2>committed to Superior Quality and Integrity</h2>
              <p>
                At Sotak, we combine industry expertise with innovative
                strategies to deliver exceptional results. From luxury real
                estate developments to large-scale construction projects and
                global trade, our commitment to quality remains unwavering.
              </p>
              <Link to="/about" className="btn btn-outline">
                Learn More About Us <ArrowRight size={16} />
              </Link>
            </Reveal>
          </div>
          <div className="about-image">
            <Reveal delay={200}>
              <img
                src="/images/7 bedroom duplex with swimming pool and BQ. EFAB Metropolis Abuja..jpeg"
                alt="Modern Building"
              />
            </Reveal>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="section section-grey">
        <div className="container">
          <Reveal>
            <div className="section-header text-center">
              <h4 className="subtitle">Our Expertise</h4>
              <h2>Comprehensive Solutions</h2>
            </div>
          </Reveal>

          <div className="services-grid">
            <Reveal delay={100} className="service-card">
              <Building size={40} className="service-icon" />
              <h3>Real Estate Development</h3>
              <p>
                Developing residential and commercial properties that stand the
                test of time.
              </p>
               <Link
                 to="/services#real-estate-development"
                 className="service-link"
               >
                 Read More
               </Link>
             </Reveal>
 
             <Reveal delay={200} className="service-card">
               <TrendingUp size={40} className="service-icon" />
               <h3>Investment Services</h3>
               <p>
                 Strategic financial guidance and investment opportunities for
                 sustainable growth.
               </p>
               <Link to="/services#investment-services" className="service-link">
                 Read More
               </Link>
             </Reveal>
 
             <Reveal delay={300} className="service-card">
               <HardHat size={40} className="service-icon" />
               <h3>Building & Construction</h3>
               <p>
                 Full-scale construction services managed by experienced
                 professionals.
               </p>
               <Link
                 to="/services#building-construction"
                 className="service-link"
              >
                Read More
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container text-center">
          <Reveal>
            <h2>Ready to Start Your Project?</h2>
            <p>
              Contact Sotak today to discuss how we can help achieve your goals.
            </p>
            <Link to="/contact#contact-form" className="btn btn-secondary">
              Get in Touch
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Home;
